interface Owner {
  name: string;
  avatar: string;
  rating: number;
  totalSwaps: number;
  memberSince: string;
  responseTime: string;
  verified: boolean;
}

interface OwnerInfoProps {
  owner: Owner;
  postedDate: string;
}

export default function OwnerInfo({ owner, postedDate }: OwnerInfoProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Vehicle Owner</h3>
      
      <div className="flex items-start gap-4 mb-4">
        <div className="relative">
          <div className="w-16 h-16 bg-gray-200 rounded-full overflow-hidden">
            <img
              src={owner.avatar}
              alt={owner.name}
              className="w-full h-full object-cover"
            />
          </div>
          {owner.verified && (
            <div className="absolute -bottom-1 -right-1 w-6 h-6 flex items-center justify-center bg-teal-500 rounded-full border-2 border-white">
              <i className="ri-check-line text-white text-xs"></i>
            </div>
          )}
        </div>
        
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="font-semibold text-gray-900">{owner.name}</h4>
            {owner.verified && (
              <span className="px-2 py-0.5 bg-teal-50 text-teal-700 text-xs font-medium rounded">
                Verified
              </span>
            )}
          </div>
          <div className="flex items-center gap-1 mb-2">
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => (
                <i
                  key={i}
                  className={`${
                    i < Math.floor(owner.rating)
                      ? 'ri-star-fill text-amber-400'
                      : 'ri-star-line text-gray-300'
                  } text-sm`}
                ></i>
              ))}
            </div>
            <span className="text-sm text-gray-600">
              {owner.rating} ({owner.totalSwaps} swaps)
            </span>
          </div>
          <p className="text-xs text-gray-500">Member since {owner.memberSince}</p>
        </div>
      </div>

      <div className="space-y-3 pt-4 border-t border-gray-200">
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600">Response Time</span>
          <span className="text-sm font-medium text-gray-900">{owner.responseTime}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600">Posted</span>
          <span className="text-sm font-medium text-gray-900">{postedDate}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600">Total Swaps</span>
          <span className="text-sm font-medium text-teal-600">{owner.totalSwaps}</span>
        </div>
      </div>

      <button className="w-full mt-4 px-4 py-2.5 bg-gray-100 text-gray-900 font-medium rounded-lg hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer">
        <i className="ri-user-line mr-2"></i>
        View Profile
      </button>
    </div>
  );
}
